import { useEffect, useState } from 'react';
import * as Base from '@base';
import { Box } from '../box';
import { useTranslation } from '../i18n';
import styles from './index.module.less';
import { useSignaturePad } from './useSignature';
import type { GraffitiProps } from './types';

export function Graffiti(props: GraffitiProps): React.ReactElement {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { isLongImage, imgRef, canvasRef, initSignaturePad } = useSignaturePad({ src: props.src });

  const handleSave = async (): Promise<void> => {
    setLoading(true);
    const file = await new Promise<Blob | null>(resolve => {
      canvasRef.current!.toBlob(resolve);
    });

    await props.onSave(file!);
  };


  useEffect(() => {
    if (props.show) {
      imgRef.current = undefined;
      setLoading(false);
      initSignaturePad();
    }
  }, [props.show, initSignaturePad]);

  return (
    <Base.Modal
      centered
      width='auto'
      title={t('涂鸦')}
      open={props.show}
      keyboard={false}
      maskClosable={false}
      onCancel={props.onCancel}
      footer={[
        <Base.Button className={styles.clearBtn} key='clear' disabled={loading} onClick={initSignaturePad}>
          {t('清空')}
        </Base.Button>,
        <Base.Button key='cancel' onClick={props.onCancel}>
          {t('取消')}
        </Base.Button>,
        <Base.Button key='submit' type='primary' loading={loading} onClick={handleSave}>
          {t('保存')}
        </Base.Button>
      ]}
    >
      <Box className={[styles.container, isLongImage ? styles.longImage : ''].join(' ')}>
        <canvas className={styles.signaturePad} ref={canvasRef} />
      </Box>
    </Base.Modal>
  );
}
